import React from "react";
import { Modal as ReactOverlaysModal } from "react-overlays";

interface ModalProps {
  open: boolean;
  children: React.ReactNode;
  onClose: () => void;
}

const Modal = ({ open, onClose, children }: ModalProps) => {
  const renderBackdrop = (props: any) => (
    <div className="modal-backdrop" {...props} />
  );
  return (
    <ReactOverlaysModal
      show={open}
      renderBackdrop={renderBackdrop}
      onBackdropClick={onClose}
      onEscapeKeyDown={onClose}
      className="modal"
    >
      <>
        <button onClick={onClose} className="modal-close-button">
          <img
            src={`${process.env.MEDIA_URL}/media/images/modal/close.svg`}
            alt="close-button"
          />
        </button>
        {children}
      </>
    </ReactOverlaysModal>
  );
};
const ModalHeader = ({ children }: { children: React.ReactNode }) => {
  return <header className="modal-header">{children}</header>;
};

const ModalBody = ({ children }: { children: React.ReactNode }) => {
  return <main className="modal-body">{children}</main>;
};

Modal.Header = ModalHeader;
Modal.Body = ModalBody;

export { Modal };
